import { createContext, useContext } from 'react'

import { LabelledField } from 'features/views/ListView/ListHeader/Filters/Advanced/types'

export type AdvancedFiltersContextValue = {
    filters: Filter[]
    addFilter: (filter: Filter) => void
    removeFilter: (id: number) => void
    updateFilter: (filter: Filter) => void
    setFilters: (filters: Filter[]) => void
    clearFilters: () => void
    fields: LabelledField[]
    recommendedFields: LabelledField[]
}

export const AdvancedFiltersContext = createContext<AdvancedFiltersContextValue | null>(null)

export function useAdvancedFiltersContext() {
    const context = useContext(AdvancedFiltersContext)
    if (!context) {
        throw new Error(
            'useAdvancedFiltersContext must be used within a AdvancedFiltersContextProvider'
        )
    }

    return context
}
